import React, { useState } from "react";
import { useTheme } from "styled-components";

import { BUTTON_STYLE } from "./defaults";

export const Button = ({
  children,
  appearance = "primary",
  onClick = () => {},
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const theme = useTheme();

  const styleObject = BUTTON_STYLE[appearance](theme);
  const hoverStyleObject = isHovering ? styleObject?.hover || {} : {};

  return (
    <button
      style={{ ...styleObject, ...hoverStyleObject }}
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {children}
    </button>
  );
};
